import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { noHeadingEditorConfig } from 'common/components/RichTextEditor/CKEditorConfig';

import RichTextEditor from 'common/components/RichTextEditor/RichTextEditor';
import { getEditMode } from 'features/divestitureDiagnostic/divestitureDiagnosticSlice';
import './Description.scss';
import { sanitize } from 'common/services/sanitizeService';

const Description = ({
  description,
  onDescriptionChange,
  isDescriptionEditable,
}) => {
  const isEditMode = useSelector(getEditMode);
  const [focused, setFocused] = useState(false);

  const isEditable = isDescriptionEditable && isEditMode;

  return (
    <div className="category-description-wrapper">
      {!isEditable && (
        <div
          className="category-description dangerously-set"
          dangerouslySetInnerHTML={{ __html: sanitize(description) }}
        />
      )}
      {isEditable && (
        <div className="category-description">
          <RichTextEditor
            richTextData={description}
            onChange={(value) => {
              onDescriptionChange(value === '' ? '<ul></ul>' : value);
            }}
            onBlur={(_, editor) => {
              setFocused(false);
              editor.ui.view.toolbar.element.style.display = 'none';
            }}
            onFocus={(_, editor) => {
              setFocused(true);
              editor.ui.view.toolbar.element.style.display = 'block';
            }}
            isFocused={focused}
            config={noHeadingEditorConfig}
          />
        </div>
      )}
    </div>
  );
};

export default Description;
